import {
  getActiveStoredAccount,
  getStoredAccounts,
  getStoredActiveAccountId,
} from "./accountSession";

export const ACCOUNT_SESSION_HEADER = "X-Account-Session";

export function getActiveSessionAlias() {
  return (
    getActiveStoredAccount(
      getStoredAccounts(),
      getStoredActiveAccountId()
    )?.session_alias || ""
  );
}

export function withSessionHeaders(headers = {}) {
  const nextHeaders = { ...headers };
  const sessionAlias = getActiveSessionAlias();

  delete nextHeaders.Authorization;
  delete nextHeaders.authorization;
  delete nextHeaders[ACCOUNT_SESSION_HEADER];
  delete nextHeaders["X-Account-Session"];
  delete nextHeaders["x-account-session"];

  if (sessionAlias) {
    nextHeaders[ACCOUNT_SESSION_HEADER] = sessionAlias;
  }

  return nextHeaders;
}

export function withSessionConfig(config = {}) {
  return {
    ...config,
    withCredentials: true,
    headers: withSessionHeaders(config.headers || {}),
  };
}

export function withSessionFetchOptions(options = {}) {
  return {
    ...options,
    credentials: "include",
    headers: withSessionHeaders(options.headers || {}),
  };
}
